import { SearchResultListItem } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/SearchResultListItem";
import { getSortValueFarm } from "@/components/layout/Navbar/ApplicationSearch/SearchBar/SearchResultMenu/search-result-menu.utils";
import { FarmRow, SearchResultItem } from "@/components/layout/Navbar/ApplicationSearch/application-search.types";
import { routes } from "@/routes";
import { generatePath } from "@/routes/routes.utils";

type Props = {
    data: FarmRow;
    onClick: (item: SearchResultItem) => void;
    className?: string;
    isRecentSearch?: boolean;
};

export const FarmListItem = (props: Props) => {
    const { data } = props;

    const url = generatePath(routes.customerDetail, {
        params: {
            customerNumber: data.CustomerNumber,
        },
        searchParams: {
            farmLicenseKey: data.FarmLicenseKey,
        },
    });

    const item: SearchResultItem = {
        type: "farm",
        data,
        sortValue: getSortValueFarm(data),
    };

    return (
        <SearchResultListItem
            label={data.FarmLicenseKey ?? "Unknown farm"}
            // @ts-expect-error FIXME: link can be undefined
            url={url}
            title={"Farm"}
            icon={"lely-icon-farm"}
            onClick={() => props.onClick(item)}
            className={props.className}
            isRecentSearch={props.isRecentSearch}
        />
    );
};
